"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onCheckNumberClickedMap = exports.getUnclaimedPrizeTablesData = exports.getClientTimeZoneDate = void 0;
var moment = __importStar(require("moment-timezone"));
var constants_1 = __importStar(require("../../../config/constants"));
var getClientTimeZoneDate = function (date) {
    var utcMoment = moment.utc(date);
    var clientTimeZoneDate = utcMoment.tz(constants_1.default.LOTTERY_TIME_ZONE);
    var formattedClientDate = clientTimeZoneDate.format('MM-DD-YYYY');
    return formattedClientDate;
};
exports.getClientTimeZoneDate = getClientTimeZoneDate;
var getUnclaimedPrizeTablesData = function (gameWithUnclaimedPrizes) {
    var unclaimedPrizeTables = [];
    gameWithUnclaimedPrizes.forEach(function (game) {
        var withoutMultiplierTable = getTableWithHeaders(game, false);
        var withMultiplierTable = getTableWithHeaders(game, true);
        if (!!withMultiplierTable) {
            unclaimedPrizeTables.push(withMultiplierTable);
        }
        if (!!withoutMultiplierTable) {
            unclaimedPrizeTables.push(withoutMultiplierTable);
        }
    });
    return unclaimedPrizeTables;
};
exports.getUnclaimedPrizeTablesData = getUnclaimedPrizeTablesData;
var getMultiplierLabel = function (gameName) {
    var normalizedGameName = gameName
        .replace(/\s/g, '')
        .replace(/-/g, '')
        .toLowerCase();
    switch (normalizedGameName) {
        case 'powerball':
            return 'Power Play';
        case 'lottoamerica':
            return 'All Star Bonus';
        case 'megamillions':
            return 'Megaplier';
        default:
            return '';
    }
};
var getTableWithHeaders = function (gameWithUnclaimedPrizes, addWithMultiplierOnly) {
    var unclaimedPrizes = gameWithUnclaimedPrizes.unclaimedPrizes.filter(function (unclaimedPrize) { return unclaimedPrize.isMultiplierPrize === addWithMultiplierOnly; });
    if (unclaimedPrizes.length) {
        var unclaimedPrizeTable_1 = {
            key: "".concat(gameWithUnclaimedPrizes.gameId, "_").concat(addWithMultiplierOnly ? 'Multiplier' : 'NonMultiplier'),
            headerName: addWithMultiplierOnly
                ? "".concat(gameWithUnclaimedPrizes.name, " with ").concat(getMultiplierLabel(gameWithUnclaimedPrizes.name))
                : gameWithUnclaimedPrizes.name,
            buttonName: addWithMultiplierOnly
                ? "".concat(gameWithUnclaimedPrizes.name, " ").concat(getMultiplierLabel(gameWithUnclaimedPrizes.name))
                : gameWithUnclaimedPrizes.name,
            gameId: gameWithUnclaimedPrizes.gameId,
            unclaimedPrizeRows: []
        };
        unclaimedPrizes.forEach(function (unclaimedPrize) {
            var prizeHumanReadable = unclaimedPrize.prizeHumanReadable, retailerName = unclaimedPrize.retailerName, id = unclaimedPrize.id, drawDate = unclaimedPrize.drawDate, retailerAddress = unclaimedPrize.retailerAddress;
            unclaimedPrizeTable_1.unclaimedPrizeRows.push({
                key: id.toString(),
                date: (0, exports.getClientTimeZoneDate)(drawDate),
                prize: prizeHumanReadable,
                retailerAddress: retailerAddress,
                retailerName: retailerName
            });
        });
        return unclaimedPrizeTable_1;
    }
    return null;
};
var onCheckNumberClickedMap = function (gameId) {
    var unclaimedGameMap = constants_1.RemoteConstants.getJson('UNCLAIMED_GAME_MAP');
    return unclaimedGameMap[gameId] || gameId;
};
exports.onCheckNumberClickedMap = onCheckNumberClickedMap;
//# sourceMappingURL=util.js.map